module.exports = __webpack_public_path__ + "img/invite.d1215a5c.svg";